export const getToken = () => localStorage.getItem('token');
export const setToken = token => localStorage.setItem('token', token);
export const deleteToken = () => localStorage.removeItem('token');

export const getMe = () => localStorage.getItem('me');
export const setMe = id => localStorage.setItem('me', id);
export const deleteMe = () => localStorage.removeItem('me');

